module.exports = __webpack_public_path__ + "media/images/emoticons/sign05-0eb2dfbede648254828285b6e026528c.gif";